/// <amd-module name="DistributedTaskUI/ServiceEndpoints/Editor/UIContributions/AzureRMEndpoint/Components/Common/EndpointErrorMessageWidget" />
import React = require("react");
import { useState, useEffect } from "react";
import { StoreManager } from "DistributedTask/Flux/StoreManager";
import { ActionsCreatorInstanceIds } from "DistributedTaskUI/ServiceEndpoints/Editor/Constants";
import { EndpointsEditorStore } from "DistributedTaskUI/ServiceEndpoints/Editor/Stores/EndpointsEditorStore";
import { MessageCard, MessageCardSeverity } from "VSSUI/MessageCard";


export function EndpointErrorMessageWidget(): JSX.Element {

    const [state, setState] = useState({
        isError: false,
        errorMessage: "",
        activityId: ""
    });
    const store = StoreManager.GetStore<EndpointsEditorStore>(EndpointsEditorStore, ActionsCreatorInstanceIds.EndpointsEditorStoreInstanceId);


    useEffect(() => {
        store.addChangedListener(onStoreChanged);

        return () => {
            store.removeChangedListener(onStoreChanged);
        };
    }, []);

    function onStoreChanged(): void {
        const storeState = store.getState();
        setState({
            activityId: storeState.activityId,
            isError: storeState.isError,
            errorMessage: storeState.errorMessage
        });
    }

    function renderActivityId(): JSX.Element {
        if (!state.activityId) {
            return null;
        }

        return <div className="flex-column" style={{ marginTop: "20px" }}>ActivityId: {state.activityId}</div>;
    }

    if (!state.isError) {
        return null;
    }

    return (
        <MessageCard
            className="flex-self-stretch margin-top-16 margin-bottom-16"
            severity={MessageCardSeverity.Error}
        >
            <div className="flex-column">{state.errorMessage}</div>
            {renderActivityId()}
        </MessageCard>);
}
